
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/vacancy-request/modals/view/view.vue', {"no_create_vacancy_permission":{"ru_RU":"У&nbsp;вас нет прав создавать и&nbsp;управлять вакансиями. Обратитесь к&nbsp;управляющему рекрутеру","en_US":"You do&nbsp;not have the rights to&nbsp;create and manage vacancies. Contact the managing recruiter"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component.options._i18n = makeI18n("src/modules/vacancy-request/modals/view/view.vue", baseTranslation);
      Component.options.beforeCreate = addHook(Component.options.beforeCreate);
      delete Component.options._Ctor;
    }
  